import STableLayout from "@/styles/STableLayout";
import { FC, Fragment, Key, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { PackOrderContext } from "../context";
import { Button, Flex, Form, Input, InputNumber, Modal, notification, Table, TableProps, Tag, Typography } from "antd";
import { PackBox, BoxStatus, PackOrderStatus } from "@/types/packing";
import { AnyObject } from "antd/es/_util/type";
import SText from "@/styles/SText";
import { useTranslation } from "react-i18next";
import usePackEnums from "../../../hooks/usePackEnums";
import { numFormmater } from "@/pages/Requirement/util";
import { CustomTabPaneContext, CustomTabPaneContextType } from "@/components/TabPane";
import { SConModal } from "@/styles/SConModal";
import usePackOrderDetail from "../hooks";
import { BoxDoType, orderSourceItems } from "@/apis/packing";
import BoxAddOrEdit from "./BoxAddOrEdit";
import { plus } from "@/utils/calc";
import BatchSeal from "./BatchSeal";
import iconFolder from "@/assets/images/fileIcon/folder.svg";
import { TAB_FILE_LIST, TAB_ITEM_KEY } from ".";

const BoxList: FC<{ readonly?: boolean }> = ({ readonly = false }) => {
  const { orderData, setOrderData, boxListRef, setSourceItems } = useContext(PackOrderContext);
  const { onOpen } = useContext<CustomTabPaneContextType<PackBox>>(CustomTabPaneContext);
  const { t } = useTranslation();
  const { getBoxStatus } = usePackEnums();
  const { doBox, loading, editBox } = usePackOrderDetail();
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openBox, setOpenBox] = useState<PackBox | null>(null);
  const [shutWeight, setShutWeight] = useState<{ nw: number, gw: number }>({ gw: 0, nw: 0 });
  const [openSealBox, setOpenSealBox] = useState<PackBox | null>(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [openBatchSeal, setOpenBatchSeal] = useState<PackBox[]>([]);
  const [keyword, setKeyword] = useState<string>('');
  const [boxRang, setBoxRang] = useState<[string, string]>(['', '']);
  const [filterd, setFilterd] = useState<number>(0);

  const parse = (no: string): { prefix: string, num: number } | null => {
    const m = no?.match(/^([A-Za-z]*)(\d+)$/);
    return m ? { prefix: m[1], num: parseInt(m[2], 10) } : null;
  };
  const { filterdList, total } = useMemo(() => {
    let filterdList: PackBox[] = [];
    if (!!orderData.boxes?.length) {
      if (filterd > 0) {
        if (!!boxRang[0] && !!!boxRang[1]) {
          filterdList = orderData.boxes.filter(b => b.boxNumber.includes(boxRang[0]));
          return { filterdList, total: filterdList.length };
        }
        if (!!!boxRang[0] && !!boxRang[1]) {
          filterdList = orderData.boxes.filter(b => b.boxNumber.includes(boxRang[1]));
          return { filterdList, total: filterdList.length };
        }
        const startInfo = parse(boxRang[0].trim());
        const endInfo = parse(boxRang[1].trim());
        if (!!!startInfo || !!!endInfo || startInfo.num > endInfo.num) {
          if (!!keyword) {
            filterdList = orderData.boxes.filter(box => {
              if (box?.items?.length) {
                return !!box.items.find(bItem => {
                  let p = bItem.product;
                  return p && p.code.includes(keyword)
                })
              } else return false;
            })
          } else filterdList = orderData.boxes;
        } else filterdList = orderData.boxes.filter(box => {
          const info = parse(box.boxNumber);
          let codeFlag = true;
          if (!!keyword) {
            if (box?.items?.length) {
              codeFlag = !!box.items.find(bItem => {
                let p = bItem.product;
                return p && p.code.includes(keyword);
              });
            } else codeFlag = false
          }
          return !!info && info.prefix === startInfo.prefix
            && info.num >= startInfo.num && info.num <= endInfo.num && codeFlag;
        });
      } else filterdList = orderData.boxes;
    }
    return { filterdList, total: filterdList.length };
  }, [orderData, filterd, parse]);

  useImperativeHandle(boxListRef, () => ({
    getSelectBox: () => orderData.boxes?.filter(box => selectedRowKeys.includes(box.id)) ?? [],
    clearSelect: () => setSelectedRowKeys([])
  }));

  const handleBox = async (type: BoxDoType, id: string) => {
    let status: BoxStatus = type === "seal" ? BoxStatus.SHUTED : BoxStatus.DRAFT;
    let boxData = (orderData.boxes || []).find(b => b.id === id);
    let netWeight: string = '0';
    if (type === "seal" && boxData) {
      if (shutWeight.gw === 0) {
        return notification.error({ message: t('warehouse.shutErr'), description: t('warehouse.gWeightNeed') })
      } else {
        boxData.items.forEach(item => netWeight = plus(netWeight, String(item.netWeight || 0)));
        await editBox({ ...boxData, netWeightG: Number(netWeight), grossWeightG: shutWeight.gw }, id, true);
      }
    }
    try {
      let res = await doBox(type, id);
      if (res) {
        if (type === "remove") {
          let newSource = await orderSourceItems(orderData.id);
          setSourceItems([...newSource]);
          setOrderData({
            ...orderData,
            boxes: (orderData.boxes || []).filter(b => b.id !== id)
          })
        } else setOrderData({
          ...orderData,
          boxes: (orderData.boxes || []).map(b => ({
            ...b,
            status: b.id === id ? status : b.status,
            netWeightG: type === "seal" && b.id === id ? Number(netWeight) : b.netWeightG,
            grossWeightG: type === "seal" && b.id === id ? shutWeight.gw : b.grossWeightG,
          }))
        })
      }
      setShutWeight({ nw: 0, gw: 0 });
      setOpenSealBox(null);
    } catch (error) { }
  };

  const handleBoxSucc = (box: PackBox, type: "ADD" | "EDIT") => {
    if (type === "ADD") {
      let boxes = [...(orderData.boxes || [])];
      boxes.push({ ...box })
      setOrderData({
        ...orderData,
        boxes,
      })
      setOpenAdd(false);
    }
    if (type === "EDIT") {
      setOrderData({
        ...orderData,
        boxes: (orderData.boxes || []).map(b => b.id === openBox?.id ? ({ ...box }) : ({ ...b })),
      });
      setOpenBox(null);
    }
  };

  const closeBatchSeal = () => {
    setSelectedRowKeys([]);
    setOpenBatchSeal([]);
  };

  const handleSealBatch = () => {
    // if (!!!selectedRowKeys.length) return notification.error({ message: t('warehouse.plBatchSeal') });
    // else {
    //   let boxes = orderData.boxes?.filter(box => selectedRowKeys.includes(box.id) && box.status === BoxStatus.DRAFT) ?? [];
    //   if(boxes.length === 0) return notification.error({ message: t('warehouse.plBatchSeal'),description:t('warehouse.filterdSeal') });
    //   let disBoxes = boxes.filter(record => !!!record?.items?.length);
    //   if (!!disBoxes.length) return notification.error({
    //     message: t('warehouse.selBoxErr'),
    //     description: (
    //       <>
    //         <div>{t('warehouse.selBoxErrTip2')}</div>
    //         <div style={{ color: "red" }}>{disBoxes.map(b => b.boxNumber).join(', ')}</div>
    //       </>
    //     )
    //   })
    //   else setOpenBatchSeal([...boxes]);
    // }
    let boxes = orderData.boxes?.filter(box => box.status === BoxStatus.DRAFT && !!box.items.length) ?? [];
    if (boxes.length === 0) return notification.error({ message: t('warehouse.noSealBox'), description: t('warehouse.filterdSeal') });
    else setOpenBatchSeal([...boxes]);
  };

  const columns: TableProps<PackBox>['columns'] = [
    {
      title: <SText text={t('warehouse.boxNo')} style={{ marginLeft: 24 }} />,
      width: 120,
      key: "number",
      fixed: "left",
      render: (_, record) => (
        <Flex align="center" gap={4}>
          <Typography.Link style={{ marginLeft: 24 }}
            onClick={() => onOpen(TAB_ITEM_KEY, record)}>
            {record.boxNumber}
          </Typography.Link>
          {!!record.items?.find(i => !!i.docId) && (
            <img
              src={iconFolder}
              alt=""
              width={20}
              height={20}
              style={{ marginLeft: 6, cursor: "pointer" }}
              onClick={() => onOpen(TAB_FILE_LIST, record)}
            />
          )}
        </Flex>
      )
    },
    // {
    //   title: <SText text={t('warehouse.boxBarcode')} />,
    //   width: 100,
    //   key: "barcode",
    //   render: (_, record) => <SText text={record.barcode} />
    // },
    {
      title: <SText text={t('warehouse.state')} />,
      width: 100,
      key: "status",
      render: (_, record) => {
        let info = getBoxStatus(record.status);
        return info && <SText tagMode color={info.color} text={info.label} />
      }
    },
    {
      title: <SText text={t('warehouse.volumeCbm')} />,
      width: 120,
      key: "volumeCbm",
      hidden: true,
      render: (_, record) => <SText text={numFormmater(record.volumeCbm)} />
    },
    {
      title: <SText text={t('warehouse.grossWeightG')} />,
      width: 120,
      key: "grossWeightG",
      render: (_, record) => <SText text={
        record.status === BoxStatus.DRAFT ? t('warehouse.toClose') :
          numFormmater(record.grossWeightG)
      } />
    },
    {
      title: <SText text={t('warehouse.netWeightG')} />,
      width: 120,
      key: "netWeightG",
      render: (_, record) => <SText text={
        record.status === BoxStatus.DRAFT ? t('warehouse.toClose') :
          numFormmater(record.netWeightG)
      } />
    },
    {
      title: <SText text={t('warehouse.packageType')} />,
      width: 120,
      key: "packageType",
      render: (_, record) => <SText text={record.packageType} />
    },
    {
      title: <SText text={t('warehouse.marksNumbers')} />,
      width: 120,
      key: "marksNumbers",
      render: (_, record) => <SText text={record.marksNumbers} />
    },
    {
      title: <SText text={t('warehouse.lengthMm')} />,
      width: 120,
      key: "lengthMm",
      render: (_, record) => <SText text={numFormmater(record.lengthMm)} />
    },
    {
      title: <SText text={t('warehouse.widthMm')} />,
      width: 120,
      key: "widthMm",
      render: (_, record) => <SText text={numFormmater(record.widthMm)} />
    },
    {
      title: <SText text={t('warehouse.heightMm')} />,
      width: 120,
      key: "heightMm",
      render: (_, record) => <SText text={numFormmater(record.heightMm)} />
    },
    {
      title: <SText text={t('warehouse.remark')} />,
      width: 120,
      key: "remark",
      render: (_, record) => <SText text={record.remark} />
    },
    {
      title: <SText text={t('common.opt')} />,
      width: 200,
      key: "opt",
      fixed: "right",
      hidden: orderData.status !== PackOrderStatus.DRAFT || readonly,
      render: (_, record) => (
        <Flex gap={2} align='center' >
          <Button type='link' disabled={record.status !== BoxStatus.DRAFT} onClick={() => setOpenBox(record)}>{t('requirement.edit')}</Button>
          {record.status === BoxStatus.DRAFT && <SConModal disable={loading === "BoxDel"} title={t('common.tip')} content={t('warehouse.delBoxTip', { no: record.boxNumber })} onOk={async () => await handleBox('remove', record.id)}>
            <Button type='text' danger disabled={loading === "BoxDel"}>{t('common.del')}</Button>
          </SConModal>}
          {record.status === BoxStatus.DRAFT && (
            <Button type='link'
              disabled={loading === "BoxSeal" || !!!record?.items?.length}
              onClick={() => setOpenSealBox(record)}
            >{t('warehouse.closeBox')}</Button>
          )}
          {record.status === BoxStatus.SHUTED && <Button type='link' disabled={loading === "BoxUnSeal" || orderData.status !== PackOrderStatus.DRAFT} onClick={() => handleBox('unseal', record.id)}>{t('warehouse.openBox')}</Button>}
        </Flex>
      )
    },
  ];

  const headerChildren = (
    <Flex style={{ flex: 1 }} justify='space-between'>
      <Flex style={{ flex: 1 }} gap={6}>
        {orderData.status === PackOrderStatus.DRAFT && !readonly && <Button type="primary" onClick={() => setOpenAdd(true)}>{t('common.add')}</Button>}
        {orderData.status === PackOrderStatus.DRAFT && !readonly && <Button type="dashed" onClick={handleSealBatch}>{t('warehouse.batchSeal')}</Button>}
        <span />
      </Flex>
      <Flex gap={6}>
        <Form.Item style={{ marginBottom: 6 }} label={t('purchase.search')}>
          <Input style={{ width: 120 }}
            placeholder={t('warehouse.searchCode')} value={keyword}
            onChange={e => setKeyword(e.target.value)}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 6 }} label={t('warehouse.searchRange')}>
          <Input style={{ width: 120 }}
            placeholder={t('warehouse.startNo')} value={boxRang[0]}
            onChange={e => { setBoxRang(last => [e.target.value, last[1]]); }}
          /> - <Input style={{ width: 120 }} value={boxRang[1]}
            placeholder={t('warehouse.endNo')}
            onChange={e => { setBoxRang(last => [last[0], e.target.value]) }}
          />
          <Button style={{ margin: "0 4px" }} type="primary" onClick={() => setFilterd(prev => prev + 1)}>{t('purchase.search')}</Button>
          <Button onClick={() => { setFilterd(0); setBoxRang(['', '']); setKeyword(''); }}>{t('warehouse.reset')}</Button>
        </Form.Item>
      </Flex>
    </Flex>
  );

  return (
    <Fragment>
      <STableLayout
        headerChildren={headerChildren}
        columns={columns as Array<AnyObject>}
        dataSource={filterdList}
        total={total}
        extHeight={100}
        pagination={false}
        scrollX={1000}
        virtual
        enableColumnResize={false}
        rowKey="id"
        rowSelection={{
          type: "checkbox",
          columnWidth: 48,
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys([...keys]),
        }}
      />
      {openAdd && <BoxAddOrEdit formType="ADD" box={null} open={openAdd} orderId={orderData.id} onClose={() => setOpenAdd(false)} onSuccess={data => handleBoxSucc(data, "ADD")} />}
      {!!openBox && <BoxAddOrEdit formType="EDIT" box={openBox} open={!!openBox} orderId={orderData.id} onClose={() => setOpenBox(null)} onSuccess={data => handleBoxSucc(data, "EDIT")} />}
      {
        !!openSealBox && <Modal title={
          <Flex gap={6} align='baseline'>
            <Typography.Text>{t('warehouse.closeBox')}</Typography.Text>
            <Tag>{openSealBox.boxNumber}</Tag>
          </Flex>
        }
          open width={400} onCancel={() => setOpenSealBox(null)} onOk={() => handleBox("seal", openSealBox.id)}>
          <Flex vertical gap={4}>
            <Form.Item label={t('warehouse.grossWeightG')} style={{ marginBottom: 4 }}>
              <InputNumber disabled={!!loading} min={0} value={shutWeight.gw}
                onChange={val => setShutWeight(last => ({ ...last, gw: val || 0 }))}
                placeholder={t('warehouse.grossWeightG')} style={{ width: "100%" }}
                changeOnWheel formatter={val => numFormmater(Number(val || 0))}
              />
            </Form.Item>
          </Flex>
        </Modal>
      }
      {
        !!openBatchSeal.length && <BatchSeal open boxes={openBatchSeal}
          onClose={closeBatchSeal}
        />
      }
    </Fragment>
  )
};

export default BoxList;